import { type MessageArgsProps, message, notification } from 'antd';
import dayjs from 'dayjs';
import type { TriggerPartnerGamesMappingResultResponse } from 'src/types/partner-games';

export const showMessage = (props: MessageArgsProps) => {
  message.open({
    duration: 2,
    ...props,
  });
};

export const showMappingResultsNotification = (data: TriggerPartnerGamesMappingResultResponse) => {
  const isRunning = data.status === 'running';
  const error = data.values.find(({ error }) => error)?.error;
  const brandsCount = data.values.length;
  const mappedGamesCount = data.values.reduce((prev, cur) => prev + cur.mappedGamesCount, 0);

  notification.open({
    description: error ? (
      <div>
        <div>Game Mapping Failed</div>
        <div>{error}</div>
      </div>
    ) : (
      <div>
        <div>
          Games Mapping {isRunning ? 'triggered' : 'finished'} {dayjs.utc(data?.updatedAt).format('DD MMM HH:mm')}{' '}
          {isRunning && `on ${brandsCount} ${brandsCount === 1 ? 'brand' : 'brands'}`}
        </div>
        {!isRunning && (
          <div>
            {mappedGamesCount} {mappedGamesCount === 1 ? 'game was' : 'games were'} mapped on {brandsCount}{' '}
            {brandsCount === 1 ? 'brand' : 'brands'}
          </div>
        )}
      </div>
    ),
    title: 'Mapping Results',
    duration: 0,
    type: error ? 'error' : undefined,
  });
};
